/**
 * Tiện ích cho luồng "tìm link Facebook thật của khách".
 *
 * Bối cảnh: external_user_id mà webhook trả về là ID phạm vi trang (PSID/ASID),
 * không mở được trang cá nhân và không lấy được avatar. Chỉ khi có UID thật ta mới
 * dựng được cả hai. UID thật do extension Khothi FB Finder ghi vào profile_link.
 */

/** Kênh Facebook (khác Instagram/Zalo/Tiktok) */
export function isFacebookChannel(channelTypeCode?: string | null): boolean {
    const code = String(channelTypeCode || "").toLowerCase();
    return code === "fb" || code === "facebook";
}

/**
 * Link tới đúng bình luận của khách, dựng từ payload webhook đã lưu.
 * Đây là điểm xuất phát để nhân viên bấm vào tên khách -> ra trang cá nhân thật.
 */
export function buildCommentPermalink(payload: any): string {
    const value = payload?.value;
    if (!value) return "";

    const commentId = String(value.comment_id || "").split("_").pop() || "";
    const permalink = String(value.post?.permalink_url || "").trim();

    if (permalink) {
        return commentId
            ? `${permalink}${permalink.includes("?") ? "&" : "?"}comment_id=${commentId}`
            : permalink;
    }

    // Không có permalink_url thì dựng từ post_id dạng "{pageId}_{postId}".
    const parts = String(value.post_id || "").split("_");
    if (parts.length === 2) {
        const base = `https://www.facebook.com/${parts[0]}/posts/${parts[1]}`;
        return commentId ? `${base}?comment_id=${commentId}` : base;
    }
    return "";
}

/**
 * Hộp thư Meta Business Suite của trang. Chỉ cần `asset_id`; KHÔNG deep link tới từng
 * hội thoại được vì `selected_item_id` không nhận PSID (đã thử: ra "Messenger User" +
 * lỗi tải). Việc dò đúng khách trong hộp thư do extension làm, khớp theo tên và tin cuối.
 *
 * Lưu ý: `asset_id` phải là page mà chính tài khoản Facebook của nhân viên quản lý.
 */
export function buildInboxUrl(pageExternalId?: string | null): string {
    if (!pageExternalId) return "";
    return `https://business.facebook.com/latest/inbox/all/?asset_id=${pageExternalId}`;
}

/** Dự phòng khi không biết page id: tìm người theo tên trên Facebook. */
export function buildPeopleSearchUrl(name?: string | null): string {
    const q = String(name || "").trim();
    if (!q) return "";
    return `https://www.facebook.com/search/people/?q=${encodeURIComponent(q)}`;
}

/* ------------------------------------------------------------------ *
 * Giao tiếp với extension Khothi FB Finder
 * ------------------------------------------------------------------ */

export const FB_FINDER_PAGE_SOURCE = "khothi-cms";
export const FB_FINDER_EXT_SOURCE = "khothi-fb-finder";

export type FbFinderUpdate = {
    customerId: number;
    profileLink: string;
    fbUid: string | null;
    /** Extension đã upload ảnh đại diện mới -> giao diện phải tải lại ảnh */
    avatarUploaded: boolean;
};

// Marker (#khothi_cc=...) do chính extension gắn lên URL khi nó mở tab ngầm, nên phía
// CMS không cần dựng nữa - trang chỉ gửi targetUrl sạch.
